import { useTranslation } from "react-i18next"
import { CustomSearchInputWrapper } from "./styles"
import { IoIosSearch, IoIosClose } from "react-icons/io"
import { useSetRecoilState } from "recoil"
import { searchByPropertyName } from "@store/index"
import { useRef, useState, useEffect, useCallback } from "react"

export default function CustomSearchInput() {
	const setSearchByPropertyName = useSetRecoilState(searchByPropertyName)
	const {
		t,
		i18n: { language },
	} = useTranslation()
	const [value, setValue] = useState("")
	const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null)

	const triggerSearch = useCallback((term: string) => {
		setSearchByPropertyName(term)
	}, [setSearchByPropertyName])

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const newVal = e.target.value
		setValue(newVal)
		if (debounceRef.current) clearTimeout(debounceRef.current)
		debounceRef.current = setTimeout(() => {
			triggerSearch(newVal)
		}, 500)
	}

	const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key === "Enter") {
			if (debounceRef.current) clearTimeout(debounceRef.current)
			triggerSearch(value)
		}
	}

	const handleClear = () => {
		if (debounceRef.current) clearTimeout(debounceRef.current)
		setValue("")
		triggerSearch("")
	}

	useEffect(() => {
		return () => { if (debounceRef.current) clearTimeout(debounceRef.current) }
	}, [])

	return (
		<CustomSearchInputWrapper lang={language === "ar" ? "ar" : "en"}>
			<div className='inputcontainer'>
				<input
					autoComplete='off'
					type='text'
					placeholder={t("COMMON.SEARCH_PROPERY")}
					value={value}
					onChange={handleChange}
					onKeyDown={handleKeyDown}
				/>
				{value ? (
					<div className='clear' onClick={handleClear}>
						<IoIosClose />
					</div>
				) : (
					<div className='search'>
						<IoIosSearch />
					</div>
				)}
			</div>
		</CustomSearchInputWrapper>
	)
}
